<template>
  <div id="cloud">
    <div class="wrapper">
      <mainHeader class="mainHeader" id="headerTop"></mainHeader>
      <div class="section1">
        <div class="title">消防云<span> — 智慧消防整体解决方案</span></div>
        <div class="stitle">设计、开发、实施、运营、保险、维保一体化服务</div>
        <div class="button1" @click="cloudClick(1,-1)">获取方案</div>
        <div class="button2" @click="cloudClick(2,-1)">申请合作</div>
      </div>
      <img :src=images[1] />
      <img :src=images[2] />
      <div class="section11">
        <div class="title">解决方案</div>
        <div class="header" id="headerScroll">
          <div class="swiper-pagination-plan" slot="pagination"></div>
        </div>
      </div>
      <div class="section2">
        <swiper class="swiperPlan" :options="swiperOptionPlan" ref="swiperPlan">
            <swiper-slide class="slideList" v-for="(value,indexx) in plans" :key="indexx">
              <div class="slide slide-box" :style="{backgroundImage:'url('+value.image+')'}">
                <div class="image"></div>
                <div class="title">{{value.title}}</div>
                <div class="describe">{{value.des}}</div>
                <div class="button" @click="cloudClick(1,-1)"><div class="name">获取方案</div><div class="next"></div></div>
                <div class="line"></div>
                <div class="stitle">功能特点</div>
                <div class="items">
                  <div class="item" v-for="(value2,index2) in value.items" :key="index2">
                    <div class="image" :style="{backgroundImage:'url('+value2.image+')'}"></div>
                    <div class="title" v-html="value2.title"></div>
                  </div>
                </div>
              </div>
            </swiper-slide>
        </swiper>
      </div>
      <img :src=images[3] />
      <img :src=images[4] />
      <img :src=images[5] />
      <div class="section3">
        <div class="header">
          <div class="left"></div>合作方式<div class="right"></div>
        </div>
        <div class="items">
          <div class="item" v-for="(value,index) in works" :key="index" :style="{backgroundImage:'url('+value.image+')'}">
            <div class="image"></div>
            <div class="title">{{value.title}}</div>
            <div class="stitle" v-html="value.stitle"></div>
            <div class="button" @click="cloudClick(2,index)">申请合作</div>
          </div>
        </div>
      </div>
      <img :src=images[6] />
      <div class="section4">
        <div class="title">消防云</div>
        <div class="stitle">智慧消防整体解决方案</div>
        <div class="button1" @click="cloudClick(1,-1)">获取方案</div>
        <div class="button2" @click="cloudClick(2,-1)">申请合作</div>
      </div>
    </div>
    <backTop class="backTop" style="bottom: 80px;"></backTop>
  </div>

</template>

<script>
import mainHeader from '../../view/header'
import backTop from '../../view/back-top'

export default{
  data () {
    return {
      isLogin: 0,
      images: [
        require('./images/icon_cloud1.jpg'),
        require('./images/icon_cloud2.jpg'),
        require('./images/icon_cloud3.jpg'),
        require('./images/icon_cloud4.jpg'),
        require('./images/icon_cloud5.jpg'),
        require('./images/icon_cloud6.jpg'),
        require('./images/icon_cloud7.jpg'),
        require('./images/icon_cloud8.jpg')],
      imageMargin: 'image-margin',
      works: [
        {title: '技术服务合作', stitle: '设备接入支持<br/>硬件设计开发商<br/>AI人工智能技术<br/>软件设计开发商<br/>行业解决方案集成商<br/>大数据解决开发商', image: require('./images/icon_cloud_item1.jpg')},
        {title: '实施服务合作', stitle: '机电施工供应商<br/>维保单位供应商<br/>物业单位供应商<br/>消防安全评估机构', image: require('./images/icon_cloud_item2.jpg')},
        {title: '品牌供应合作', stitle: '品牌供应合作<br/>视频设备供应商<br/>消防设备供应商', image: require('./images/icon_cloud_item3.jpg')},
        {title: '其他服务合作', stitle: '保险服务单位<br/>消防培训机构<br/>消防设计单位<br/>咨询服务单位<br/>市场代理合作<br/>各领域专业能力供应商', image: require('./images/icon_cloud_item4.jpg')}
      ],
      plans: [
        {title: '智慧消防火灾预警系统',
          image: require('./images/icon_cloud_p1.jpg'),
          des: '实时采集联网单位火灾报警控制器的报警信息和运行状态信息，数据上传至云平台后台进行智能分析和管理，实现对联网单位自动报警系统的全方位感知、全过程监控。能够提前发现各种故障隐患，保障自动报警系统各项设施正常运行。有效做到火灾事故早发现、早报警、早扑灭，确保联网建筑的消防安全。',
          items: [
            {title: '零建设成本<br/>租用式服务', image: require('./images/icon_s1.png')},
            {title: '语音、短信、APP<br/>三种通知模式', image: require('./images/icon_s2.png')},
            {title: '24小时无间断<br/>监测燃气浓度', image: require('./images/icon_s11.png')},
            {title: '设备易安装<br/>组网方式简单', image: require('./images/icon_s4.png')}]},
        {title: '智慧用电安全管理系统',
          image: require('./images/icon_cloud_p2.jpg'),
          des: '智慧用电监控系统是对用电的实时监测和控制，用电的不当或线路的故障都可能引火灾的发生。平台可实现火灾隐患巡查、远程控制、精确定位等功能，针对工业企业、娱乐场所、商业街等电气设备多、用电量大场所实现用电安全事故早发现、早解决，有效降低电气火灾风险。',
          items: [
            {title: '零建设成本<br/>租用式服务', image: require('./images/icon_s1.png')},
            {title: '语音、短信、APP<br/>三种通知模式', image: require('./images/icon_s2.png')},
            {title: '24小时监测设备<br/>运行状态', image: require('./images/icon_s3.png')},
            {title: '无线传输数据<br/>施工简单', image: require('./images/icon_s5.png')}]},
        {title: '可燃气体检测管理系统',
          image: require('./images/icon_cloud_p3.jpg'),
          des: '目前餐饮行业、家庭住宅等场所大多使用天然气作燃料，这些气体有害、易爆炸，隐患事故多，如气体泄漏不能及时发现和处理，会带来灾难性危害。消防云智慧消防物联网云服务平台可实现可燃气体实时监测管理，当超过标限值或设备故障，系统会自动报警，自动切断阀门，有效预防家庭住宅、餐厅、酒店等有火灾隐患的场所因燃气泄漏引发的恶性事故。',
          items: [
            {title: '零建设成本<br/>租用式服务', image: require('./images/icon_s1.png')},
            {title: '语音、短信、APP<br/>三种通知模式', image: require('./images/icon_s2.png')},
            {title: '24小时监测设备<br/>运行状态', image: require('./images/icon_s3.png')},
            {title: '无线传输数据<br/>施工简单', image: require('./images/icon_s5.png')}]},
        {title: '智慧消防水监测系统',
          image: require('./images/icon_cloud_p4.jpg'),
          des: '当前消防水设备因长期不用出现功能失效、锈死、欠压等现象，这些问题给专业消防人员在紧急情况下的用水带来严重影响,给城市消防工作带来巨大隐患。消防云智慧消防物联网云服务平台具有实现管网压力、水池液位、消防栓水压的智能监测功能，解决了管网无水或欠压、阀门误关闭、设备运行故障等问题，具有操作流程简单、成本低、维护简单等优势。',
          items: [
            {title: '零建设成本<br/>租用式服务', image: require('./images/icon_s1.png')},
            {title: '语音、短信、APP<br/>三种通知模式', image: require('./images/icon_s2.png')},
            {title: '24小时监测设备<br/>运行状态', image: require('./images/icon_s3.png')},
            {title: '结合地图显示<br/>运维监控简单', image: require('./images/icon_s6.png')}]},
        {title: '应急救援智慧指挥系统',
          image: require('./images/icon_cloud_p5.jpg'),
          des: '智慧指挥中心随时掌握辖区内所有消防车辆的实时位置及实时动态和信息；当接到报警时，消防指挥中心会向消防车上配有的导航仪推送报警的详细资料及灭火预案资料，并为消防车提供到达火警点的最佳行车路线。使消防官兵在路上就能及时了火灾的详细情况及时安排作战计划，一旦到达火灾发生地，及时投入战斗。',
          items: [
            {title: '零建设成本<br/>租用式服务', image: require('./images/icon_s1.png')},
            {title: '语音、短信、APP<br/>三种通知模式', image: require('./images/icon_s2.png')},
            {title: '24小时视频实时监控<br/>车辆定位监控', image: require('./images/icon_s7.png')},
            {title: '车备水源管理<br/>可视化管理', image: require('./images/icon_s8.png')}]},
        {title: '城市消防物联网远程',
          image: require('./images/icon_cloud_p6.jpg'),
          des: '学校、医院、商场、工厂等场所人口密集、物品繁多、环境复杂，给社会火灾防 控工作带来巨大压力。消防云智慧消防物联网云服务平台通过专用物联网传输模块进行联网，实现重点单位消防设施的分权限、分层级的日常监控管理，并和监控中心、维保单位数据共享监控，确保联网建筑的消防安全。',
          items: [
            {title: '零建设成本<br/>租用式服务', image: require('./images/icon_s1.png')},
            {title: '语音、短信、APP<br/>三种通知模式', image: require('./images/icon_s2.png')},
            {title: '24小时联网监测<br/>多方联动', image: require('./images/icon_s9.png')},
            {title: '数据共享<br/>大数据应用', image: require('./images/icon_s10.png')}]}
      ],
      swiperOptionPlan: {
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        initialSlide: 0,
        pagination: {// 分页器
          el: '.swiper-pagination-plan',
          clickable: true,
          renderBullet: function (index, className) {
            var titles = ['智慧消防火灾预警系统', '智慧用电安全管理系统', '可燃气体检测管理系统', '智慧消防水监测系统', '应急救援智慧指挥系统', '城市消防物联网远程']
            return '<span class="' + className + '">' + titles[index] + '<span></span></span>'
          }
        },
        fadeeffect: true,
        on: {
          slideChangeTransitionStart: function () {
            console.log('swiper-----------' + this.activeIndex)
            let offset = 0
            if (this.activeIndex >= 2) {
              offset = 100 + 140 * (this.activeIndex - 2)
            } else {
              offset = 0
            }
            setTimeout(function () {
              let dom = document.getElementById('headerScroll')
              dom.scrollTo(offset, dom.scrollTop)
            }, 200)
          }
        }
      }
    }
  },
  methods: {
    cloudClick: function (index, type) { // index 1 获取方案 2 申请合作 type 申请合作类型下标
      if (this.isLogin === 0) {
        this.$router.push({ path: 'login', query: { back: 1 } })
      } else {
        this.$router.push({ path: 'pcloud', query: {type: index, ctype: type} })
      }
    }
  },
  watch: {
    $router () {
    }
  },
  components: { // 注册组件
    mainHeader,
    backTop
  },
  mounted () {
    // 登录状态
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 1) {
        _this.isLogin = 1
      }
    })

    setTimeout(function () {
      scrollTo(0, 0)
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }, 100)
  }
}
</script>

<style scoped>
  .wrapper{
    background-color: #F6F6F6;
    width: 100%;
    /*margin-bottom: 70px;*/
  }
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
  }
  img{
    width: 100%;
    display: block;
  }
  .section1{
    margin-top: 55px;
    position: relative;
    height: 160px;
    background-image: url("./images/icon_cloud1.jpg");
    background-size: cover;
    background-position: center;
    color: #ffffff;
  }
  .section1 .title{
    position: absolute;
    top: 35px;
    height: 25px;
    left: 15px;
    font-size: 20px;
    font-weight: bold;
  }
  .section1 .title span{
    font-size: 12px;
    font-weight: normal;
  }
  .section1 .stitle{
    position: absolute;
    top: 68px;
    height: 15px;
    left: 15px;
    font-size: 12px;
  }
  .section1 .button1{
    position: absolute;
    top: 100px;
    width: 70px;
    height: 25px;
    line-height: 25px;
    left: 15px;
    font-size: 12px;
    background-color: #C41335;
    text-align: center;
  }
  .section1 .button2{
    position: absolute;
    top: 100px;
    width: 70px;
    height: 25px;
    line-height: 25px;
    left: 95px;
    font-size: 12px;
    text-align: center;
    border: solid #ffffff 0.5px;
    box-sizing: content-box;
  }
  .section11{
    position: relative;
    height: 100px;
    background-color: #3A4145;
    border-bottom: solid 2px #c41335;
    box-sizing: content-box;
  }
  .section11 .title{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-family: "SourceHanSansCN-Bold";
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
  }
  .section11 .header {
    position: absolute;
    top: 70px;
    width: 100%;
    overflow-x: scroll;
  }
  .section11 .header::-webkit-scrollbar{
    display: none;
  }
  .section11 .header .swiper-pagination-plan{
    position: relative;
    height: 30px;
    /*width: 840px;*/
    width: 855px;
    margin-left: 15px;
    /*margin: 0 15px;*/
  }
  .section2{
    position: relative;
    height: 400px;
    background-color: #3A4145;
    /*background-color: pink;*/
    /*border: solid 1px coral;*/
  }
  .section2 .slideList{
    margin-top: 0px;
  }
  .section2 .slideList .slide-box{
    position: relative;
    width: 100%;
    height: 400px;
    background-size: cover;
  }
  /*.slide-box .htitle {*/
  /*   position: absolute;*/
  /*   top: 0px;*/
  /*   width: 100%;*/
  /*   height: 60px;*/
  /*   line-height: 60px;*/
  /*   font-family: "SourceHanSansCN-Bold";*/
  /*   font-size: 20px;*/
  /*   font-weight: bold;*/
  /*   text-align: center;*/
  /*   color: #ffffff;*/
  /* }*/
  .slide-box .title {
    position: absolute;
    top: 15px;
    left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 15px;
    color: #ffffff;
  }
  .slide-box .describe {
    position: absolute;
    top: 45px;
    left: 15px;
    right: 10px;
    line-height: 18px;
    font-size: 12px;
    color: #ffffff;
  }
  .slide-box .button{
    position: absolute;
    top: 170px;
    width: 135px;
    height: 35px;
    left: 15px;
    background-color: #C41335;
    text-align: center;
  }
  .slide-box .button .name{
    position: absolute;
    top: 0px;
    left: 20px;
    height: 35px;
    line-height: 35px;
    color: #ffffff;
    font-size: 14px;
  }
  .slide-box .button .next{
    position: absolute;
    top: 11px;
    left: 110px;
    height: 13px;
    width: 14px;
    background-image: url("./images/icon_cloud_arrow.png");
    background-size: cover;
  }
  .slide-box .line{
    position: absolute;
    top: 230px;
    left: 15px;
    right: 15px;
    /*width: 100%;*/
    height: 0px;
    border: dashed 0.5px #ffffff;
  }
  .slide-box .stitle{
    position: absolute;
    top: 250px;
    left: 15px;
    height: 15px;
    font-size: 15px;
    color: #ffffff;
  }
  .slide-box .items{
    position: absolute;
    top: 290px;
    width: 100%;
  }
  .slide-box .items .item {
    position: relative;
    width: 50%;
    height: 30px;
    float: left;
    color: #ffffff;
  }
  .slide-box .items .item:nth-child(3){
    margin-top: 20px;
  }
  .slide-box .items .item:nth-child(4){
    margin-top: 20px;
  }
  .slide-box .items .item .image {
    position: absolute;
    left: 15px;
    top: 0px;
    height: 30px;
    width: 30px;
    background-size: contain;
  }
  .slide-box .items .item .title {
    position: absolute;
    left: 57px;
    top: 0px;
    line-height: 15px;
    font-size: 12px;
  }
  .section3{
    position: relative;
    height: 540px;
    background-color: #2b3033;
  }
  .section3 .header {
    position: relative;
    height: 55px;
    line-height: 55px;
    font-family: "SourceHanSansCN-Bold";
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
  }
  .section3 .header .left{
    position: absolute;
    top: 23px;
    left: 0px;
    height: 8.5px;
    width: 105px;
    background-image: url("./images/icon_cloud_line2.png");
    background-size: cover;

  }
  .section3 .header .right{
    position: absolute;
    top: 23px;
    right: 0px;
    height: 8.5px;
    width: 105px;
    background-image: url("./images/icon_cloud_line1.png");
    background-size: cover;
  }
  .section3 .items{
    position: absolute;
    top: 55px;
    width: 100%;
  }
  .section3 .items .item {
    position: relative;
    width: calc(50% - 20px);
    height: 230px;
    float: left;
    margin-left: 10px;
    background-size: cover;
    background-position: center;
    color: #ffffff;
  }
  .section3 .items .item:nth-child(1){
    margin-left: 15px;
  }
  .section3 .items .item:nth-child(2){
    margin-left: 10px;
  }
  .section3 .items .item:nth-child(3){
    margin-top: 10px;
    margin-left: 15px;
  }
  .section3 .items .item:nth-child(4){
    margin-top: 10px;
    margin-left: 10px;
  }
  .section3 .items .item .image {
    position: absolute;
    right: 11px;
    top: 15px;
    height: 17px;
    width: 15px;
    background-image: url("./images/icon_cloud_s.png");
    background-size: cover;
  }
  .section3 .items .item .title {
    position: absolute;
    left: 15px;
    top: 15px;
    height: 15px;
    font-size: 14px;
    font-weight: bold;
  }
  .section3 .items .item .stitle {
    position: absolute;
    left: 15px;
    top: 44px;
    height: 15px;
    line-height: 20px;
    font-size: 12px;
  }
  .section3 .items .item .button{
    position: absolute;
    top: 194px;
    width: 65px;
    height: 25px;
    line-height: 25px;
    left: 15px;
    font-size: 12px;
    background-color: #C41335;
    text-align: center;
  }
  .section4{
    position: relative;
    height: 70px;
    background-image: url("./images/icon_cloud8.jpg");
    background-size: cover;
    background-position: center;
    color: #ffffff;
  }
  .section4 .title{
    position: absolute;
    top: 15px;
    height: 20px;
    left: 15px;
    font-size: 15px;
    font-weight: bold;
  }
  .section4 .stitle{
    position: absolute;
    top: 35px;
    height: 20px;
    left: 15px;
    font-size: 12px;
  }
  .section4 .button1{
    position: absolute;
    top: 23px;
    width: 70px;
    height: 25px;
    line-height: 25px;
    right: 95px;
    font-size: 12px;
    background-color: #C41335;
    text-align: center;
  }
  .section4 .button2{
    position: absolute;
    top: 23px;
    width: 70px;
    height: 25px;
    line-height: 25px;
    right: 15px;
    font-size: 12px;
    text-align: center;
    border: solid #ffffff 0.5px;
    box-sizing: content-box;
  }
  .image-margin{
    /*margin-top :-1px;*/
  }
  /*img:first-of-type{*/
  /*  margin-top: 55px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/view/cloud/index.vue